
import { gsap, Power4, Back } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import Keyboard, { KEYS } from '../_app/cuchillo/core/Keyboard';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from "../_app/cuchillo/utils/Ease";
import { isReducedMotion } from '../_app/cuchillo/core/Basics';
import { Functions } from '../_app/cuchillo/utils/Functions';

gsap.registerPlugin(SplitText);


export class TitularMagneticController {
  static _titles = {};
  static _observer = null;
  static _options = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
  };
  
  static init() {
    this.setupObserver();
    this.getTitles();
  };

  static getTitle(selector = "[data-text-animation]") {
      const dom = GetBy.selector(selector)[0];
      const title = new TitularMagneticReveal(dom);
      return title;
  };

  static getTitles(selector = "[data-text-animation]") {
    
    [...GetBy.selector(selector)].map(dom => {
      const id = Functions.getId(dom);
      const title = new TitularMagneticReveal(dom);
    
      this._titles[id] = title;

      if (!isReducedMotion) {
        this._observer.observe(dom);
      }
    });
  };

  static setupObserver() {
    if (this._observer) {
      this._observer.disconnect();
    }

    if (!isReducedMotion) {
      this._observer = new IntersectionObserver((entries) => { this.checkObserver(entries) }, this._options);
    }
  }

  static checkObserver(entries, observer) {
    entries.forEach(entry => {
      const id = Functions.getId(entry.target);
      const title = this._titles[id];

      if (entry.isIntersecting) {
        title.show();
      } else {
        title.reset();
      }
    });
  }

  static dispose() {
    if (this._observer) { this._observer.disconnect(); }

    Object.entries(this._titles).map((item) => { 
      item[1].dispose()
    });

    this._titles = {}
    this._observer = null;
  }
};


export class TitularMagneticReveal {

  _dom;
  _timeline;
  _content;
  _items = [];
  _actual = 0;
  _options = {
    type: "words",
    time: .8,
    delay: .1
  };

  constructor(__dom, __opts = {}) {
    this._dom = __dom;
    this._content = GetBy.class('content', this._dom)[0];
    this._options = {
      ...this._options,
      ...__opts
    };

    this.setupText();
  }

  setupText() {
    // Split el texto en palabras — cada palabra queda dentro de un <div class="word">
    const split = new SplitText(this._content, {
      type: this._options.type,
      wordsClass: "word"           // clase aplicada a cada span de palabra
    });

    this._items = split[this._options.type]; // array de spans

    // Envolver cada palabra en un mask container para el reveal desde abajo
    this._items.forEach(word => {
      const mask = document.createElement('span');
      mask.classList.add('word-mask');
      // Clonar el span de la palabra y meterlo dentro del mask
      word.parentNode.insertBefore(mask, word);
      mask.appendChild(word);
    });

    // Estado inicial: palabras fuera de vista hacia abajo
    gsap.set(this._items, {
      yPercent: 1000,
    });

    // Construir el timeline (paused, se lanza con show())
    this._timeline = gsap.timeline({ paused: true })
      .to(this._items, {
        yPercent: 0,
        opacity: 1,
        duration: this._options.time,
        ease: "expo.out",
        stagger: this._options.delay   // delay en segundos entre palabras
      });
  }

  reset() {
    this._actual = 0;
    this._timeline.pause(0);
    gsap.set(this._items, { yPercent: 1000, opacity: 0 });
  }

  show() {
    if (this._actual >= this._items.length) {
      this.enabled = false;
      return;
    }

    this._timeline.play();
    this._actual = this._items.length; // marca como completado
  }
}
